import React from 'react';

import styles from './ButtonProceed.module.scss';
import btnBackground from '../../../assets/images/btn_proceed_to_checkout.png';
import btnBackgroundDisabled from '../../../assets/images/btn_grey.png';

const ButtonProceed = ({ text, onClick, isSmall, isDisabled }) => {

    return (
        <div
            className={`${styles.buttonProceed} ${isSmall ? styles.small : ''} ${isDisabled ? styles.disabled : ''}`}
            onClick={!isDisabled ? () => onClick() : null}
        >
            <img className={styles.btnBackground} src={isDisabled ? btnBackgroundDisabled : btnBackground} alt={''} />
            <div className={styles.btnText}>{text}</div>
        </div>
    );
};

export default ButtonProceed;